import React, { useState, memo } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { useQueryClient, useIsFetching, useIsMutating } from "react-query";

import { BOOTSTRAP_VARIANTS } from "../../constants/common";
import { Button, GridView, Loading } from "../../components/commons";
import { showErrorNotification } from "../../utils/toastr";

import { IconEdit } from "../../assests/icons";

import {
  useGetDepartments,
  useCreateDepartments,
  useUpdateDepartment,
} from "../../api";

import EditDepartment from "./EditDepartment";

const Departments = ({ clientAccountId }) => {
  const { t } = useTranslation();

  const isFetching = useIsFetching();
  const isMutating = useIsMutating();

  const queryClient = useQueryClient();
  const [selectedDepartment, setDepartment] = useState(null);
  const [query, setQuery] = useState({ page: 1, pageSize: 7 });

  const { data: departments, refetch: refetchDepartments } = useGetDepartments(
    clientAccountId,
    query.page,
    query.pageSize
  );
  const { mutateAsync: updateDepartment } = useUpdateDepartment();
  const { mutateAsync: createDepartments } = useCreateDepartments();

  const handleCreateDepartment = (departmentData) => {
    const data = { ...departmentData };
    data.client_account_id = clientAccountId;
    if (data.id) {
      updateDepartment(data).then(() => {
        setDepartment(null);
        refetchDepartments();
        queryClient.invalidateQueries("dimension-values");
      });
    } else {
      createDepartments(data).then(() => {
        setDepartment(null);
        refetchDepartments();
        queryClient.invalidateQueries("dimension-values");
      });
    }
  };

  const handleQueryChange = (data) => {
    const q = {
      ...(query || {}),
      ...data,
    };
    setQuery(q);
  };

  return (
    <div className="detail-page">
      <Loading childLoading loading={isFetching > 0 || isMutating > 0} />
      {selectedDepartment === null ? (
        <div className="business-partner-list">
          <div className="business-partner-gridview">
            <GridView
              columns={[
                {
                  Header: t("master_data.gridview.id"),
                  accessor: "sequence_number",
                  align: "left",
                  maxWidth: "9%",
                },
                {
                  Header: t("master_data.gridview.name"),
                  accessor: "name",
                  align: "left",
                  maxWidth: "15%",
                },
                {
                  Header: "",
                  accessor: "delete",
                  align: "left",
                  maxWidth: "6%",
                  className: "delete-wrap",
                  Cell: (cellProps) => (
                    <span
                      className="delete-icon"
                      role="button"
                      onClick={() => setDepartment(cellProps.row.original)}
                    >
                      <IconEdit />
                    </span>
                  ),
                },
              ]}
              data={(departments || {}).departments}
              pages={(departments || {}).pages}
              relativeRowHeight={30}
              onStateChange={(q) => handleQueryChange(q)}
              emptyStateTitle=""
            />
          </div>
          <div className="text-right">
            <Button
              size="md40"
              className="add-button"
              variant={BOOTSTRAP_VARIANTS.SECONDARY}
              text={t("master_data.add_new_department")}
              onClick={() => setDepartment(undefined)}
            />
          </div>
        </div>
      ) : (
        <EditDepartment
          onBack={() => setDepartment(null)}
          onSave={handleCreateDepartment}
          showErrorNotification={showErrorNotification}
          department={selectedDepartment}
        />
      )}
    </div>
  );
};

export default memo(Departments);
